import i18next from 'i18next'
import ChainedBackend from 'i18next-chained-backend'
import resourcesToBackend from 'i18next-resources-to-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { InfaceLocales } from '@inface-sdk/web-auth'
import gwResources from '../../i18next/locales/*/*.json'

const supportedLngs = [
  'ko',
  'en',
  'ja',
  'es',
  'es-MX',
  'es-ES', // 다국어 추가 예정
  'pt-BR',
  'de',
  'nl',
  'fr',
  'it',
  'pl',
  'tr',
  'ru',
  'th',
  'zh-TW',
  'zh-CN',
  'id',
  'vi',
  'hi',
  'ar',
]

function generateResources() {
  const resources = {}

  // eslint-disable-next-line no-restricted-syntax
  for (const [locale, keyValueObj] of Object.entries(InfaceLocales)) {
    resources[locale] = {
      inface: keyValueObj, // inface namespace
    }
  }

  return resources
}

const infaceResources = generateResources()

async function init() {
  await i18next
    .use(ChainedBackend)
    .use(LanguageDetector)
    .init({
      debug: false,
      supportedLngs,
      fallbackLng: {
        'es-MX': ['es-MX', 'es', 'en'],
        'es-ES': ['es-ES', 'en'],
        default: ['en'],
      },
      preload: ['en', 'ko'],
      ns: ['inface', 'google', 'common', 'iac', 'playnow', 'security-check', 'sso'], // namespace
      defaultNS: 'common',
      fallbackNS: 'inface',
      backend: {
        backends: [
          resourcesToBackend(infaceResources),
          resourcesToBackend(gwResources),
        ],
      },
      detection: {
        order: ['querystring', 'cookie', 'navigator', 'htmlTag'],
        lookupQuerystring: 'locale',
        lookupCookie: '_iflocale',
        cookieDomain: '.nexon.com',

        excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

        convertDetectedLanguage: (lng) => {
          const browserLngs = navigator.languages || [navigator.language || navigator.userLanguage]
          const formattedLng = lng.replace('_', '-')
          const baseLang = formattedLng.split('-')[0]
          const fallbackLng = i18next.options.fallbackLng.default[0]

          // 1. 우선적으로 supportedLngs에 있는 언어를 반환
          if (supportedLngs.includes(formattedLng)) return formattedLng
          if (supportedLngs.includes(baseLang)) return baseLang

          // 2. 브라우저 설정언어를 지원 언어 목록과 교차하여 첫 번째 지원 언어를 반환
          const detectedLng = browserLngs.find((lang) => supportedLngs.includes(lang))

          // 3. 감지된 언어가 없으면 fallback 언어 반환
          return detectedLng || fallbackLng
        },
      },
      interpolation: {
        prefix: '{',
        suffix: '}',
      },
    })

  window.$i18next = i18next
  window.$t = i18next.t
  window.dispatchEvent(new Event('onLoadLocales'))
}

init()
